import { ColDef } from '@ag-grid-enterprise/all-modules'
import { AgGridColumnType } from '@/shared/models/ag-grid.model'
import i18n from '@/lang/i18n'
import { AlarmType } from '@/modules/configurationModule/detail/notifications/models/alarms'
import { getEnumColumnGridOptions } from '@/grid/base-grid-options'
import { VtGridTextFormatter } from '@/grid/vt-grid-text-formatter'

export const alarmsGridColumnDefs =
    (alarmTypes: AlarmType[]): ColDef[] => [
        { type: AgGridColumnType.CUSTOM_CHECKBOX },
        {
            ...getEnumColumnGridOptions(alarmTypes, 'code', 'name'),
            filterParams: {
                ...getEnumColumnGridOptions(alarmTypes, 'code', 'name').filterParams,
                textFormatter: (from: string) => VtGridTextFormatter.entityStatusStateFormatter(from, alarmTypes)
            },
            headerName: i18n.tc('configuration.grid.type'),
            colId: 'alarmType',
            field: 'alarmType.name',
            type: AgGridColumnType.TEXT,
            minWidth: 400,
            flex: 2
        },
        {
            type: AgGridColumnType.CHECK_ICON,
            headerName: i18n.tc('configuration.grid.active'),
            field: 'active',
            flex: 1,
            minWidth: 80
        }
    ]
